import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult() {
  const { result } = useParams();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(result === "erfolg" ? "checking" : "cancelled");

  useEffect(() => {
    if (result !== "erfolg" || !sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch {}
      attempts += 1;
      if (attempts < 15) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [result, sessionId]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6" data-testid="payment-result-page">
      <div className="bg-white border border-zinc-200 rounded-2xl p-10 max-w-md w-full text-center shadow-sm">
        {status === "checking" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto animate-spin text-zinc-900" />
            <h1 className="font-display text-xl font-semibold mt-6">Zahlung wird bestätigt…</h1>
            <p className="text-sm text-zinc-500 mt-2">Bitte einen Moment warten.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-10 h-10 mx-auto text-zinc-900" />
            <h1 className="font-display text-xl font-semibold mt-6" data-testid="payment-success-title">Abonnement aktiviert</h1>
            <p className="text-sm text-zinc-500 mt-2">Ihre Zahlung war erfolgreich. Ihr Tarif ist jetzt aktiv.</p>
            <Link to="/app" data-testid="payment-success-continue"
              className="mt-6 inline-block bg-zinc-900 text-white font-medium px-6 py-2.5 rounded-lg hover:bg-zinc-700 transition-colors">
              Zum Dashboard
            </Link>
          </>
        )}
        {status === "timeout" && (
          <>
            <Loader2 className="w-10 h-10 mx-auto text-zinc-400" />
            <h1 className="font-display text-xl font-semibold mt-6">Bestätigung ausstehend</h1>
            <p className="text-sm text-zinc-500 mt-2">Die Zahlungsbestätigung steht noch aus. Prüfen Sie Ihren Abo-Status in Kürze unter „Abo & Abrechnung“.</p>
            <Link to="/app/abrechnung" className="mt-6 inline-block bg-zinc-900 text-white font-medium px-6 py-2.5 rounded-lg">Zur Abrechnung</Link>
          </>
        )}
        {status === "cancelled" && (
          <>
            <XCircle className="w-10 h-10 mx-auto text-zinc-400" />
            <h1 className="font-display text-xl font-semibold mt-6" data-testid="payment-cancel-title">Zahlung abgebrochen</h1>
            <p className="text-sm text-zinc-500 mt-2">Es wurde keine Zahlung ausgeführt. Sie können es jederzeit erneut versuchen.</p>
            <Link to="/app/abrechnung" data-testid="payment-cancel-retry"
              className="mt-6 inline-block bg-zinc-900 text-white font-medium px-6 py-2.5 rounded-lg hover:bg-zinc-700 transition-colors">
              Zurück zur Abrechnung
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
